import { IDs } from '../../../helpers/IDs';
import { getGewerk } from '../../../main/functions/getGewerk';


export function createStructureForKennziffern(kenn_def: Array<any>, kenn_dyn: Array<any>, strucutre_dynamic: string) {
    const attJahr = { NAME: 'Jahr', TYPE: 'INT', KEY: 'jahr', REQUIRED: 'KEY' };
    const attStandort = {
        NAME: 'Standort',
        KEY: 'standort_tid',
        TYPE: 'INT',
        REQUIRED: 'YES',
        OPTS: {
            ENTITY: 'standort',
            IDENTIFIER: 'tid',
            INPUT: 'name',
            MODUL: 'etool'
        },
        FILTER_MODE: 'EXCEL'
    };
    const arr_def = kenn_def.map((k_d: any) => {
        return { NAME: k_d.name + ' [' + k_d.einheit + ']', TYPE: 'DOUBLE', KEY: k_d.kuerzel, FORMAT: 'DEZIMAL(2)', REQUIRED: 'NO' };
    });
    const arr_dyn = kenn_dyn.map((k_d: any) => {
        return { NAME: k_d.name + ' [' + k_d.einheit + ']', TYPE: 'DOUBLE', KEY: k_d.kuerzel, FORMAT: 'DEZIMAL(2)', REQUIRED: 'NO' };
    });
    const att_bemerkung = { NAME: 'Bemerkung', TYPE: 'TEXT', KEY: 'bemerkung', FORMAT: 'TEXTAREA' };
    return {
        TITEL: 'Kennzahlen - Jahreswerte',
        SRC: {
            type: 'NO_INIT',
            id: strucutre_dynamic
        },
        ATTS: [attJahr, attStandort, ...arr_def, ...arr_dyn, att_bemerkung]
    };
}
export function prepareStructureForKennziffern(data: any) {
    const gewerk = getGewerk(data);
    const kenn_dyn = data[IDs.ENT_KENNZAHLEN_DYNAMISCH];
    const kenn_def = Array.isArray(data[IDs.ENT_KENNZAHLEN_DEFINTION]) ?
        data[IDs.ENT_KENNZAHLEN_DEFINTION].filter((k_def: any) =>
            k_def.branchen_gewerke_tid_orig === gewerk &&
            k_def.is_gewerk && k_def.is_gewerk === 1 &&
            (!k_def.is_berechnet || k_def.is_berechnet === 0)) : [];
    return { kenn_dyn, kenn_def };
}
